import { useTranslations } from 'next-intl';

import { UiKitButtonBase } from '@/fo/ui/kit/button/base';
import { UiKitRatingBlock } from '@/fo/ui/kit/rating/block';
import { UiReviewRecommendPercent } from '@/fo/ui/review/recommend/percent';
import { UiReviewTileProduct } from '@/fo/ui/review/tile/product';

import { Product, ReviewsData, ReviewsFilter, ReviewTab } from '../../types';
import { RatingFilter } from '../RatingFilter/RatingFilter';

import { styles } from './Sidebar.styles';

export interface SidebarProps {
  reviewsData: ReviewsData;
  product: Product;
  activeTab: ReviewTab;
  onActionClick?: (tab: ReviewTab) => void;
  filters: ReviewsFilter;
  onChangeFilters: (filters: ReviewsFilter) => void;
}

export function Sidebar({
  reviewsData,
  product,
  activeTab,
  onActionClick,
  filters,
  onChangeFilters
}: SidebarProps) {
  const t = useTranslations();

  const slots = styles();
  const buttonText =
    activeTab === ReviewTab.Reviews
      ? t('review.buttons.leaveReview')
      : t('review.buttons.askQuestion');

  return (
    <div className={slots.base()}>
      <div className={slots.product()}>
        <UiReviewTileProduct
          title={product.title}
          tags={
            product.volume
              ? Array.isArray(product.volume)
                ? product.volume
                : [product.volume]
              : []
          }
          imageUrl={product.imageUrl}
          url={product.url}
        />
      </div>
      <div className={slots.recommendPercent()}>
        <UiReviewRecommendPercent percent={reviewsData.recommendPercent} />
      </div>
      <div className={slots.action()}>
        <UiKitButtonBase
          onClick={() => onActionClick?.(activeTab)}
          className={slots.actionButton()}
        >
          {buttonText}
        </UiKitButtonBase>
      </div>
      {activeTab === ReviewTab.Reviews && (
        <>
          <UiKitRatingBlock
            value={reviewsData.rating}
            className={slots.rating()}
          />
          <RatingFilter
            reviewsData={reviewsData}
            filters={filters}
            onChange={onChangeFilters}
          />
        </>
      )}
    </div>
  );
}
